
import { checklists } from '../../../mocks/resourcesLibrary';

export default function ChecklistShowcase() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 rounded-full mb-6">
            <i className="ri-checkbox-multiple-line text-teal-600" />
            <span className="text-teal-700 text-sm font-medium">Never Miss a Step</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Professional <span className="text-teal-600">Checklists</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Ensure quality and compliance on every job. Our checklists are used by 10,000+ tradies across Australia.
          </p>
        </div>

        {/* Checklists */}
        <div className="grid lg:grid-cols-2 gap-8">
          {checklists.map((checklist, index) => (
            <div
              key={checklist.id}
              className="group flex flex-col sm:flex-row gap-5 bg-slate-50 rounded-2xl p-5 border border-slate-100 hover:border-teal-200 hover:shadow-lg hover:shadow-teal-100/50 transition-all duration-500"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              {/* Image */}
              <div className="sm:w-48 h-40 sm:h-auto flex-shrink-0 rounded-xl overflow-hidden">
                <img
                  src={checklist.image}
                  alt={checklist.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-1 bg-teal-100 text-teal-700 rounded-md text-xs font-semibold">
                    Checklist
                  </span>
                  {checklist.isNew && (
                    <span className="px-2 py-1 bg-amber-100 text-amber-700 rounded-md text-xs font-semibold">NEW</span>
                  )}
                  {checklist.isPremium && (
                    <span className="px-2 py-1 bg-amber-500 text-white rounded-md text-xs font-semibold flex items-center gap-1">
                      <i className="ri-vip-crown-2-line text-[10px]" /> PRO
                    </span>
                  )}
                </div>

                <h3 className="font-semibold text-slate-900 mb-1 group-hover:text-teal-700 transition-colors">
                  {checklist.title}
                </h3>
                <p className="text-sm text-slate-500 mb-3 line-clamp-2 leading-relaxed">
                  {checklist.description}
                </p>

                {/* Checklist Items Preview */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {checklist.items.map((item) => (
                    <span key={item} className="inline-flex items-center gap-1 px-2 py-1 bg-white rounded-md text-xs text-slate-600 border border-slate-100">
                      <i className="ri-check-double-line text-teal-500 text-[10px]" />
                      {item}
                    </span>
                  ))}
                </div>

                {/* Footer */}
                <div className="mt-auto flex items-center justify-between">
                  <div className="flex items-center gap-3 text-xs text-slate-400">
                    <span>{checklist.format} • {checklist.fileSize}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-download-2-line" />
                      {checklist.downloads.toLocaleString()}
                    </span>
                  </div>
                  <button
                    className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-semibold cursor-pointer whitespace-nowrap transition-all ${
                      checklist.isPremium
                        ? 'bg-amber-500 text-white hover:bg-amber-600'
                        : 'bg-teal-600 text-white hover:bg-teal-700'
                    }`}
                  >
                    <i className={checklist.isPremium ? 'ri-vip-crown-2-line' : 'ri-download-line'} />
                    {checklist.isPremium ? 'Unlock Pro' : 'Download'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
